import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { admin, ready } = useAuth();
  if (!ready || admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0c1633]">
        <Loader2 className="animate-spin text-[#E84B1C]" size={32} />
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin" replace />;
  return children;
}
